// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__L48Nr","burgerImg":"menu_burgerImg__4uRdO","yo":"menu_yo__r1QKG"};